import JourneyWithNextSchedule from '../../JourneyWithNextSchedule';
import { JourneyActionPayload, getCurrentSchedule } from '..';
import { Button as ButtonSmall } from '../style';
import Link from '@mui/material/Link';
import { ISchedules } from '../../../../services/journey.service';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

export const VideoCallAvailableSmall = ({ journey }: JourneyActionPayload) => {
  const currentSchedule = getCurrentSchedule(journey);

  return (
    <>
      <JourneyWithNextSchedule
        journey={journey}
        schedule={currentSchedule as ISchedules}
        actionButton={
          <Link href={currentSchedule?.teleUrl} target="_blank">
            <ButtonSmall variant="contained" endIcon={<ArrowForwardIcon />}>
              Entrar na videochamada
            </ButtonSmall>
          </Link>
        }
      />
    </>
  );
};
